export default "__VITE_ASSET__4PbC2wtY__"